module.exports = __webpack_public_path__ + "images/d72198742fb4ab4d7fd65243977617a4.svg";